import apiClient from '../apiClient';
import ArticlesController from '@/controllers/ArticlesController';

export const getArticleById = async (id) => {
  try {
    const response = await apiClient.get(`${ArticlesController.ArticleById}`, {
      params: { id }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching article data:', error);
    throw error;
  }
};

export const getTrendingTags = async () => {
  try {
    const response = await apiClient.get(`${ArticlesController.TrendingTags}`)
    return response.data.data;
  } catch (error) {
    console.error('Error fetching trending tags:', error);
    throw error;
  }
};

export const getTrendingArticles = async (count) => {
  try {
    const response = await apiClient.get(`${ArticlesController.TrendingArticles}`,
        { params: { count } }
    );
    return response.data.data;
  } catch (error) {
    console.error('Error fetching trending articles:', error);
    throw error;
  }
};

export const loadMoreComments = async (ArticleId, PageNumber) => {
  try {
    const response = await apiClient.get(`${ArticlesController.LoadMoreComments}`,
        { params: { ArticleId, PageNumber } }
    );
    return response.data;
  } catch (error) {
    console.error('Error loading more comments:', error);
    throw error;
  }
}

/**
 * Filters articles based on the provided search criteria.
 *
 * @param {Object} options - The search options.
 * @param {string[]} [options.tags] - The tags to filter by.
 * @param {string} [options.userId] - The user ID to filter by.
 * @param {string} [options.categoryId] - The category ID to filter by.
 * @param {string} [options.searchTerm] - The search term to filter by.
 * @param {boolean} [options.isDraft] - Whether to filter for draft articles.
 * @param {number} [options.pageIndex] - The page index for pagination.
 * @param {number} [options.pageSize] - The page size for pagination.
 * @returns {Promise<Object>} - The filtered articles.
 */
export const filterArticles = async ({
  tag,
  userId, 
  categoryId, 
  searchTerm, 
  isDraft, 
  pageIndex, 
  pageSize
}) => {
  try {
    // Define query parameters
    const queryParams = {
      tag ,
      UserId: userId,
      CategoryId: categoryId,
      searchTerm,
      IsDraft: isDraft,
      PageIndex: pageIndex,
      PageSize: pageSize
    };

    // Filter out any undefined or null parameters
    Object.keys(queryParams).forEach(
      key => queryParams[key] === undefined && delete queryParams[key]
    );

    // Make the POST request with tags in the body and the rest in query parameters
    const response = await apiClient.get(
      `${ArticlesController.FilterArticles}`, 
      { params: queryParams }  // Query parameters
    );
    
    return response.data;
  } catch (error) {
    console.error('Error filtering articles:', error);
    throw error;
  }
};
/*********NEWW Services**********/
/**
 * Adds a comment to an article.
 * 
 * @param {string} commentContent - The content of the comment to be added.
 * @returns {Promise<Object>} - The response data from the server.
 */
export const addAtricleComment = async (commentContent) => {
  try {
    let response = await apiClient.post('/Comments',  commentContent );
    return response.data; 
  } catch (error) {
    // Handle any errors that occur during the request
    throw error; 
  }
}

/*******************/
/**
 * Deletes a comment from an article.
 * 
 * @param {number|string} commentId - The ID of the comment to be deleted.
 * @returns {Promise<Object>} - The response data from the server.
 */
export const deleteAtricleComment = async (commentId) => {
  try {
    // Send a DELETE request to delete the specified comment
    let response = await apiClient.delete(`/Comments?commentId=${commentId}`);
    return response.data; 
  } catch (error) {
    // Handle any errors that occur during the request
    throw error;
  }
}

/*******************/
/**
 * Edits an existing comment on an article.
 * 
 * @param {number|string} commentId - The ID of the comment to be edited.
 * @param {string} newContent - The new content to update the comment with.
 * @returns {Promise<Object>} - The response data from the server.
 */
export const editAtricleComment = async (commentId, newContent) => {
  try {
    // Send a PUT request to update the specified comment
    let response = await apiClient.put(`/Comments?commentId=${commentId}`, newContent);
    return response.data; 
  } catch (error) {
    // Handle any errors that occur during the request
    throw error;
  }
}
